import { useEffect } from "react"

import type { PainLevel } from "@productlane/db/browser"

interface PriorityForm {
	setValue: (name: "priority", value: string) => void
}

// Linear priorities: 0 none, 1 urgent, 2 high, 3 medium, 4 low.
const linearPriorityByPainLevel: Partial<Record<PainLevel, number>> = {
	HIGH: 2,
	MEDIUM: 3,
	LOW: 4,
}

export function painLevelToLinearPriority(
	painLevel: PainLevel | null | undefined,
) {
	return painLevel ? linearPriorityByPainLevel[painLevel] : undefined
}

// Waits for Linear's priority list so the seeded value is one the picker offers.
export function useSeedPriorityOnOpen(
	form: PriorityForm,
	isOpen: boolean,
	priority: number | undefined,
	availablePriorities: { priority: number }[] | null | undefined,
) {
	const isAvailable =
		priority !== undefined &&
		!!availablePriorities?.some((option) => option.priority === priority)
	useEffect(() => {
		if (isOpen && isAvailable) form.setValue("priority", String(priority))
	}, [form, isOpen, isAvailable, priority])
}
